module.exports = __webpack_public_path__ + "media/images/truyenfull-logo-919bb1ea4a55d484817c2aca1c1b4afc.png";